import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

import "./styles/LightSwitch.css";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import UserStatus from "../../components/UserStatus";
import AddPoleModal from "../../components/addPoleForm";

import img1 from "/1.png";
import img2 from "/2.png";
import arrowR from "/ArrowR.png";

function LightSwitch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [allPoles, setAllPoles] = useState([]);
  const [filteredPoles, setFilteredPoles] = useState([]);
  const [isAddPoleVisible, setIsAddPoleVisible] = useState(false);
  const [masterPoleCount, setMasterPoleCount] = useState(0);
  const [subordinatePoleCount, setSubordinatePoleCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const navigate = useNavigate();

  const goToPoleDetails = (pole) => {
    const scheduleLightBulbs =
      pole.schedule_light_bulbs === "No schedule light bulbs"
        ? []
        : pole.schedule_light_bulbs;

    navigate("/poledetails", {
      state: {
        poleId: pole.id,
        mainPoleName: pole.name,
        mainPoleCode: pole.code,
        deviceCode: pole.hardware_id,
        firmwareVersion: pole.firmware_version,
        mainPoleLocation: pole.location,
        mainPoleLat: pole.lat,
        mainPoleLng: pole.lng,
        mainPoleActive: pole.active,
        mainSecondaryPoleCount: pole.secondary_pole_count,
        installationDate: pole.installation_date,
        hasScreen: pole.has_screen,
        screenId: pole.screen_id,
        screenModel: pole.screen_model,
        screenInstall: pole.screen_installation_date,
        lightActive: pole.custom_schedule_light_bulbs_active,
        branchName: pole.branch_name,
        cameras: pole.cameras,
        schedule_light_bulbs: scheduleLightBulbs,
        schedule_light_bulbs_rule: pole.schedule_light_bulbs_rule,
        custom_schedule_light_bulbs_active:
          pole.custom_schedule_light_bulbs_active,
        ...pole,
      },
    });
  };

  const handleAddPoleClick = () => {
    setIsAddPoleVisible(true);
  };

  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = allPoles.filter(
      (pole) =>
        pole.name.toLowerCase().includes(term) ||
        pole.code.toLowerCase().includes(term)
    );
    setFilteredPoles(filtered);
    setCurrentPage(1);
  };

  const fetchAllPoles = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/poles`);
      setAllPoles(response.data.mainPoles);
      setFilteredPoles(response.data.mainPoles);
      setMasterPoleCount(parseInt(response.data.totalMainPoles, 10));
      setSubordinatePoleCount(parseInt(response.data.totalSecondaryPoles, 10));
    } catch (error) {
      console.error("Error fetching poles:", error);
    }
  };

  useEffect(() => {
    fetchAllPoles();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPoles.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="containerPage">
      <br />
      <br />
      <h1 className="userManagement">การจัดการเสาไฟ</h1>

      <div className="sectinoAddbuttom">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหารหัสเสา"
            value={searchTerm}
            onChange={handleSearch}
          />
          <div>
            <img src={filter} alt="filter" className="filter-user" />
          </div>
        </div>
      </div>
      <button className="add_button" onClick={handleAddPoleClick}>
        + เพิ่มเสา
      </button>

      <div>
        <div className="pole-counts">
          <p>
            เสาหลักทั้งหมด <label>{masterPoleCount}</label> เสา |&nbsp;{" "}
          </p>
          <p>
            {" "}
            เสารองทั้งหมด <label> {subordinatePoleCount} </label> เสา
          </p>
        </div>
      </div>

      {isAddPoleVisible && (
        <AddPoleModal
          isVisible={isAddPoleVisible}
          onClose={() => setIsAddPoleVisible(false)}
          onSave={fetchAllPoles}
        />
      )}

      {currentItems.length === 0 ? (
        <Box
          mt={4}
          mb={4}
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="90%"
          height="200px"
          bgcolor="#344054"
          borderRadius="8px"
          flexDirection="column"
          color="#fff"
          p={3}
          sx={{ marginLeft: "50px" }} 
        >
          <SearchOffIcon style={{ fontSize: 50, marginBottom: 16 }} />
          <Typography
            variant="h6"
            fontFamily='"IBM Plex Sans Thai", sans-serif'
          >
            ไม่มีข้อมูลที่ตรงกับการค้นหา
          </Typography>
        </Box>
      ) : (
        currentItems
          .filter((pole) => pole.is_master)
          .map((pole) => (
            <div
              key={pole.id}
              className="pole-info"
              onClick={() => goToPoleDetails(pole)}
            >
              <div className="pole-info-title">
                <div className="statuslight1">
                  <label className="labePole">เสาหลัก</label>
                  <div className="statuslight">
                    <UserStatus isOnline={pole.active} />
                  </div>
                </div>
                <p className="up">รหัสเสาหลัก</p>
                <h1 className="up">{pole.code}</h1>
              </div>

              <div className="polestaus2">
                <label className="labePole">เสารอง</label>
                <p>มีเสารองทั้งหมด</p>
                <h1>{pole.secondary_pole_count}</h1>
              </div>

              <div className="polestaus3">
                <p>สาขา {pole.name || "###"}</p>{" "}
                <p>
                  <img src={img1} alt="Location icon" />
                  {pole.location}
                </p>
                <p>
                  <img src={img2} alt="Coordinates icon" />
                  {pole.lat}, {pole.lng}
                </p>
              </div>
              <img
                src={arrowR}
                alt="arrow"
                className="arrowr"
                onClick={() => goToPoleDetails(pole)}
              />
            </div>
          ))
      )}

      <div className="paginationMain">
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>

          {Array.from({
            length: Math.ceil(
              filteredPoles.filter((pole) => pole.is_master).length /
                itemsPerPage
            ),
          }).map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={currentPage === index + 1 ? "active" : ""}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage ===
              Math.ceil(
                filteredPoles.filter((pole) => pole.is_master).length /
                  itemsPerPage
              )
            }
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
}

export default LightSwitch;
